import { render, staticRenderFns } from "./IntegralWater.vue?vue&type=template&id=5a88d912&scoped=true"
import script from "./IntegralWater.vue?vue&type=script&lang=js"
export * from "./IntegralWater.vue?vue&type=script&lang=js"
import style0 from "./IntegralWater.vue?vue&type=style&index=0&id=5a88d912&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a88d912",
  null
  
)

export default component.exports